<template lang="pug">
  .product-invoice
    y-dialog(fill-height fluid v-model="showModal" transition="fade-transition" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable persistent max-width="600px")
      v-card
        v-card-title.px-5
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-arrow-left
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('order_history') }}

        v-card-text.py-2.px-0
          div.px-5
            v-row(no-gutters)
              v-col.shrink.pr-3
                eva-icon(name="person-outline" :fill="$vuetify.theme.themes[$theme].primary" width="18" height="18")
              v-col
                p.c1.primary--text {{ lead.name }}
            v-row(no-gutters)
              v-col.shrink.pr-3
                eva-icon(name="phone-outline" :fill="$vuetify.theme.themes[$theme].primary" width="18" height="18")
              v-col
                p.c1.primary--text {{ lead.phone | phoneFormat }}

          v-divider.basic300.my-1

          div(v-if="isFetching" align="center")
            v-progress-circular.my-12(:width="2" :size="50" color="primary" indeterminate)

          template(v-else)
            template(v-for="(history, index) in histories")
              div.px-5.mb-4
                div.d-flex.align-center.mt-4
                  div.c2.primary--text # {{ history.rid }} 
                    span.c1.primary400--text {{ history.created | displayDate }} at {{ history.created | displayTime }}
                  v-spacer
                  v-chip.text-uppercase.my-auto.button-AA-tiny(small outlined label :color="history.status | leadStatusColor" :style="{ 'background-color': chipBackgroundColor(history.status) + '!important' }") {{ history.status | leadStatusDisplay }}
                div.d-flex.align-center
                  eva-icon.mt-1.mr-2(name="link-outline" :fill="$vuetify.theme.themes[$theme].primary400" width="20" height="20")
                  div.c1.primary400--text {{ history.form.name }}
                  v-spacer
                  eva-icon.mt-1.mr-2(name="credit-card-outline" :fill="$vuetify.theme.themes[$theme].primary400" width="20" height="20")
                  div.c1.primary400--text {{ totalPrice(history.products) | displayPrice }}
                template(v-if="totalQuantity(history.products) > 0")
                  div.d-flex.align-center.mb-2(v-for="(p,  index) in history.products")
                    div.p2.primary--text.pr-1 {{ p.name }}
                    v-spacer
                    div.p2.primary--text.pl-1 x {{ p.quantity }}
              v-divider.basic300

            div.ma-4
              y-pagination(v-model="page" :pageSize="fetchCount" :count="count")

</template>

<script>
import { mapActions } from 'vuex'
import UpdateCompanyDetails from '@/components/dialogs/settings/UpdateCompanyDetails.vue'

export default {
  name: 'ViewHistory',
  props: ['open', 'lead'],
  components: { UpdateCompanyDetails },
  data: () => ({
    isFetching: true,
    fetchCount: 10,
    page: 1,
    // totalPage: 1,
    count: 1,
    histories: []
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    numbering () {
      return this.fetchCount*(this.page-1)
    }
  },
  watch: {
    showModal: {
      immediate: true,
      handler(val) {
        if (val) {
          this.fetchHistory()
        }
      }
    },
    page (val) {
      if (val) {
        this.isFetching = true,
        this.fetchHistory()
      }
    },
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchHistory() {
      this.$axios.get('/leads/', { params: { form__company: this.lead.company, page: this.page, page_size: this.fetchCount, phone: this.lead.phone }})
      .then(resp => {
        this.histories = resp.data.results
        this.count = resp.data.count
        // const totalCount = resp.data.count
        // if (totalCount % this.fetchCount == 0) {
        //   this.totalPage = totalCount/this.fetchCount
        // } else {
        //   this.totalPage = totalCount/this.fetchCount + 1
        // }
        // this.totalPage = parseInt(this.totalPage)
        this.isFetching = false
      })
      .catch(() => {})
    },
    totalQuantity (his) {
      if (!his) return 0
      return his.reduce((sum, p) => {
        return sum + p.quantity
      }, 0)
    },
    totalPrice (his) {
      if (!his) return 0
      return his.reduce((sum, p) => {
        return sum + (p.price * p.quantity)
      }, 0)
    },
    table_height () {
      return ((screen.availHeight * 0.9) - 152) + 'px'
    },
    chipBackgroundColor (status) {
      if (status === 'new') {
        return this.$vuetify.theme.themes[this.$theme].infoT08
      } else if (status === 'follow_up') {
        return this.$vuetify.theme.themes[this.$theme].warningT08
      } else if (status === 'partial_payment') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      } else if (status === 'reject') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === 'processed') {
        return this.$vuetify.theme.themes[this.$theme].successT08
      } else if (status === 'shipped') {
        return this.$vuetify.theme.themes[this.$theme].warningT08
      } else if (status === 'received') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      } else if (status === 'cancelled') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === 'error') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === '') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      }
      return this.$vuetify.theme.themes[this.$theme].basic600T08
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "order_history": "Order History"
  },
  "id": {
    "order_history": "Riwayat Pesanan"
  }
}
</i18n>
